import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

/**
 * Atom to manage the visibility state of the keyboard shortcuts modal
 */
export const keyboardHelpModalOpenAtom = atom(false);

/**
 * Atom to manage the visibility state of the command palette
 */
export const commandPaletteOpenAtom = atom(false);

/**
 * Controls the archive view toggle in the sidebar.
 * Set from the command palette, consumed by SidebarLayout.
 */
export const archiveViewAtom = atom(false);

/**
 * Signals the sidebar to enter rename mode for a specific environment.
 * Set to true from the command palette, consumed by the Env component in the sidebar.
 */
export const renameEnvironmentAtom = atomFamily((_environmentId: string) => atom(false));

/**
 * Holds the ID of the environment currently in rename mode, or null.
 * Only one environment can be renamed at a time — setting this to a new ID
 * automatically cancels the previous rename.
 */
export const renamingEnvironmentIdAtom = atom<string | null>(null);

/**
 * Monotonically increasing counter that signals the environment details view
 * to reveal the "Ports & Services" drawer tab. Incrementing the counter
 * (rather than using a boolean) ensures the effect fires even when the user
 * triggers the action multiple times in a row.
 *
 * Set from the command palette service start/stop actions, consumed by
 * EnvironmentDetailsPanel and SuperOnaEnvironmentDetailsPanel's BottomDrawer.
 */
export const revealServicesAtom = atom(0);

/**
 * Monotonically increasing counter that signals SuperOnaEnvironmentContent
 * to switch its active tab back to "conversation". Incremented by the right
 * panel when the user sends comments, requests a review, or creates a PR.
 */
export const switchToConversationAtom = atom(0);
